import { request } from '../config.js'

// 登录
export const login = (params) => {
  return request.postjson({
    url: '/user/login',
    data: JSON.stringify(params)
  })
}

// // 登出
export const logout = () => {
  return request.get({
    url: '/user/logout',
  })
}

// 检验登录信息
export const logouserinfo = () => {
  return request.get({
    url: '/user/checkLogin',
  })
}


export const unlock = (params) => {
  return request.postjson({
    url: '/user/appeal/unlock',
    data: JSON.stringify(params)
  })
}


